export interface CreateDutyLogParams {
  employeeId: string;
  baseId?: string;
  aircraftId?: string;
  dutyPeriodStartTime?: Date;
  dutyPeriodEndTime?: Date;

  comments?: string;
  justification?: string;
  restJustification?: string;
}

export interface UpdateDutyLogParams extends CreateDutyLogParams {
  id: string;
  isActive: boolean;
  updatedAt?: Date;
}

export interface DutyLogEntity extends UpdateDutyLogParams {
  employeeFirstName?: string;
  employeeLastName?: string;
}

export function dutyLogIdoriginatesFromGoldenHour(dutyLogId: string) {
  return !isNaN(+dutyLogId);
}

export function originatesFromGoldenHour(dutyLog: DutyLogEntity) {
  return dutyLogIdoriginatesFromGoldenHour(dutyLog.id);
}
